import React from 'react';

import format from 'string-format';
import AntTime from '../utils/AntTime';
import calculator from '../utils/calculator';
import AntLocalization from '../utils/AntLocalization';
// import $ from 'jquery';
import TreeList, { Paging } from 'devextreme-react/tree-list';
import { TextBox, CheckBox, SelectBox, TextArea, NumberBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Tooltip } from 'devextreme-react/tooltip';

import { Template } from 'devextreme-react/core/template';
import AntGridBar from './AntGridBar';
import AntGridLink from './AntGridLink';
import AntQueryStore from './AntQueryStore';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [],
            searchText: '',
            searchConditions: {},
            focusedRow: null,
            sortByColumn: null,
            sortType: null,
            defaultPageSize: this.props.defaultPageSize
                ? this.props.defaultPageSize
                : this.props.allowedPageSizes
                ? this.props.allowedPageSizes[0]
                : 7
        };

        this.API = this.props.API;
        this.load = this.load.bind(this);
        this.refresh = this.refresh.bind(this);
        this.repaint = this.repaint.bind(this);
        this.onOptionChanged = this.onOptionChanged.bind(this);
        this.onCellClick = this.onCellClick.bind(this);
        this.clearSelection = this.clearSelection.bind(this);
        this.selectedRows = this.selectedRows.bind(this);
        this.getSelectedObjectId = this.getSelectedObjectId.bind(this);
        this.focusedRow = this.focusedRow.bind(this);
        this.showColumnChooser = this.showColumnChooser.bind(this);
        this.hideColumnChooser = this.hideColumnChooser.bind(this);
        this.setPageSize = this.setPageSize.bind(this);
        this.setPageIndex = this.setPageIndex.bind(this);
        this.resetVisibility = this.resetVisibility.bind(this);
        this.resetColumnVisibility = this.resetColumnVisibility.bind(this);
        this.getSearchConditions = this.getSearchConditions.bind(this);
        this.getQueryFields = this.getQueryFields.bind(this);
        this.getSearchText = this.getSearchText.bind(this);
        this.getPageSize = this.getPageSize.bind(this);
        this.getPageIndex = this.getPageIndex.bind(this);
        this.getOrderBy = this.getOrderBy.bind(this);
        this.getOrderType = this.getOrderType.bind(this);
        this.isAllowQuery = this.isAllowQuery.bind(this);
        this.getCachedData = this.getCachedData.bind(this);
        this.getKeyField = this.getKeyField.bind(this);
        this.onFiltering = this.onFiltering.bind(this);
        this.beginUpdate = this.beginUpdate.bind(this);
        this.endUpdate = this.endUpdate.bind(this);

        this.getColumns = this.getColumns.bind(this);

        var that = this;
        var treeName = this.props.storageKey;
        if (!treeName) treeName = this.props.name ? this.props.name : this.props.API ? this.props.API.entityName : this.props.entityName;
        if (!treeName) treeName = this.props.url;

        if (this.props.dataSourceHelper) this.dataSource = this.props.dataSourceHelper.getDataSource(treeName);
        if (!this.dataSource) {
            this.dataSource = new AntQueryStore({
                key: this.props.keyExpr,
                API: this.props.API,
                url: this.props.url,
                loadFunc: this.props.loadFunc,
                remotePaging: false,

                getSearchConditions: that.getSearchConditions,
                getQueryFields: that.getQueryFields,
                getSearchText: that.getSearchText,
                getPageSize: that.getPageSize,
                getPageIndex: that.getPageIndex,
                getOrderBy: that.getOrderBy,
                getOrderType: that.getOrderType,
                isAllowQuery: that.isAllowQuery,
                onFiltering: that.onFiltering
            });
            if (this.props.dataSourceHelper) this.props.dataSourceHelper.setDataSource(treeName, this.dataSource);
        } else {
            this.dataSource.getSearchConditions = this.getSearchConditions;
            this.dataSource.getQueryFields = this.getQueryFields;
            this.dataSource.getSearchText = this.getSearchText;
            this.dataSource.getPageSize = this.getPageSize;
            this.dataSource.getPageIndex = this.getPageIndex;
            this.dataSource.getOrderBy = this.getOrderBy;
            this.dataSource.getOrderType = this.getOrderType;
            this.dataSource.isAllowQuery = this.isAllowQuery;
            this.dataSource.onFiltering = this.onFiltering;
        }

        if (this.props.actionItems instanceof Array) {
            this.props.actionItems.forEach((item) => {
                if (item.name && item.widget !== 'Button' && item.widget !== 'Menu')
                    this.state.searchConditions[item.name] = item.defaultValue !== undefined ? item.defaultValue : false;
            });
        }
    }

    beginUpdate() {
        if (this.tree) this.tree.beginUpdate();
    }

    endUpdate() {
        if (this.tree) this.tree.endUpdate();
    }

    componentDidMount() {
        this.refresh();
    }

    getColumns() {
        return this.state.columns;
    }

    getSearchConditions() {
        if (this.props.actionItems instanceof Array) {
            this.props.actionItems.forEach((item) => {
                if (item.name && item.widget !== 'Button' && item.widget !== 'Menu' && this.state.searchConditions[item.name] === undefined)
                    this.state.searchConditions[item.name] = item.defaultValue !== undefined ? item.defaultValue : false;
            });
        }

        if (this.props.searchConditions) {
            if (typeof this.props.searchConditions === 'function') {
                var obj = this.props.searchConditions();
                if (obj) this.state.searchConditions = { ...this.state.searchConditions, ...obj };
            } else this.state.searchConditions = { ...this.state.searchConditions, ...this.props.searchConditions };
        }

        var obj = { ...this.state.searchConditions };

        if (this.props.searchFields instanceof Array) {
            Object.keys(obj).map((k) => {
                var found = this.props.searchFields.find((f) => f === k || (typeof f === 'object' && f.alias === k));
                if (!found) {
                    if (this.props.actionItems instanceof Array) found = this.props.actionItems.find((f) => f.name === k);
                }
                if (!found) obj[k] = undefined;
            });
        }

        obj = { ...obj, filterBySelected: undefined };

        Object.keys(obj).map((k) => {
            if (obj[k] === null) obj[k] = undefined;
        });

        Object.keys(obj).forEach((key) => {
            if (obj[key] === undefined) {
                delete obj[key];
            }
        });

        return obj;
    }

    getQueryFields() {
        var ar = ['created_at', 'checksum', 'id', 'code', this.props.parentIdExpr, this.props.keyExpr];

        if (this.props.columns instanceof Array) ar.push(...Array.from(this.props.columns, (c) => c.dataField));

        if (this.props.getQueryFields) {
            var fields = this.props.getQueryFields();
            if (fields instanceof Array) ar.push(...fields);
        }

        ar = ar
            .filter((v) => Boolean(v))
            .filter((v, index, self) => {
                return self.indexOf(v) === index;
            });

        return ar;
    }

    getSearchText() {
        return this.state.searchText;
    }

    getOrderBy() {
        return this.state.sortByColumn;
    }

    getOrderType() {
        return this.state.sortType;
    }

    isAllowQuery() {
        this.getSearchConditions();
        if (this.props.searchConditionsRequired && (!this.state.searchConditions || Object.keys(this.state.searchConditions).length === 0))
            return false;

        if (this.props.isAllowQuery && typeof this.props.isAllowQuery === 'function') return this.props.isAllowQuery();

        return true;
    }

    getKeyField() {
        return this.props.keyExpr ? this.props.keyExpr : 'id';
    }

    getCachedData() {
        if (this.dataSource) return this.dataSource.getCachedData();
        return null;
    }

    onFiltering(e) {
        var rows = e.data;

        if (rows instanceof Array) {
            var key = this.props.keyExpr ? this.props.keyExpr : 'id';
            var parentKey = this.props.parentIdExpr;

            if (parentKey) {
                rows = rows.map((c) => {
                    var parent = rows.find((p) => p[key] === c[parentKey]);
                    if (!parent) return { ...c, [parentKey]: undefined };
                    return { ...c };
                });
            }

            return { data: rows, totalCount: rows.length };
        }
        return { data: [], totalCount: 0 };
    }

    getPageIndex() {
        var pageIndex = this.tree ? this.tree.option('paging.pageIndex') : undefined;
        if (pageIndex === undefined || pageIndex === null) pageIndex = 0;
        return pageIndex;
    }

    setPageIndex(index) {
        if (this.tree) return this.tree.option('paging.pageIndex', index);
    }

    setPageSize(size) {
        if (this.tree) return this.tree.option('paging.pageSize', size);
    }

    getPageSize() {
        if (this.tree) return this.tree.option('paging.pageSize');
        return null;
    }

    async load(searchObj, clearSelection) {
        if (this.tree) this.tree.beginUpdate();

        if (typeof searchObj == 'object') {
            this.state.searchConditions = searchObj;
            if (searchObj.searchText) {
                this.state.searchText = searchObj.searchText;
                this.state.searchConditions.searchText = undefined;
            }
        }

        this.getSearchConditions();

        if (clearSelection) this.clearSelection();

        if (this.getPageIndex() != 0) this.setPageIndex(0);

        await this.dataSource.reset(null, true, clearSelection);

        this.refresh(true);
        if (this.tree) this.tree.endUpdate();
    }

    refresh(changesOnly) {
        if (this.tree) this.tree.refresh(changesOnly);
        this.resetColumnVisibility();
    }

    async repaint() {
        if (this.tree) {
            await this.dataSource.willGetLastResult();
            this.tree.refresh(true);
        }
    }

    clearSelection() {
        if (this.tree) this.tree.clearSelection();
    }

    selectedRows() {
        if (this.tree) return this.tree.getSelectedRowsData();
        return [];
    }

    getSelectedObjectId() {
        var key = this.props.keyExpr ? this.props.keyExpr : 'id';
        var data = this.selectedRows();
        if (data && data instanceof Array && data.length == 1 && data[0][key]) return data[0][key];
        return null;
    }

    focusedRow() {
        return this.state.focusedRow;
    }

    showColumnChooser() {
        if (this.tree) this.tree.showColumnChooser();
    }

    hideColumnChooser() {
        if (this.tree) this.tree.hideColumnChooser();
    }

    onFocusedRowChanged(e) {
        const dataRow = e.row && e.row.data;
        this.setState(
            {
                focusedRow: dataRow ? dataRow : null
            },
            () => {
                if (this.props.onFocusedRowChanged) this.props.onFocusedRowChanged(this.state.focusedRow);
            }
        );
    }

    onSelectionChanged(e) {
        var rows = this.selectedRows();
        if (this.actionBar) {
            this.actionBar.showEdit(rows.length == 1);
            this.actionBar.showDelete(rows.length > 0);
        }
        if (this.props.onSelectionChanged) this.props.onSelectionChanged(rows);
    }

    onKeyDown(e) {}

    onOptionChanged(e) {
        if (e.fullName === 'paging.pageSize') {
            if (this.getPageIndex() != 0) this.setPageIndex(0);
        }

        if (e.name === 'columns' && String(e.fullName).endsWith('].sortOrder')) {
            var colIndex = parseInt(String(e.fullName).replace('columns[', '').replace('].sortOrder', ''));
            var fieldName = this.tree ? this.tree.columnOption(colIndex).dataField : undefined;
            if (fieldName && (fieldName != this.state.sortByColumn || e.value != this.state.sortType))
                this.setState({
                    sortByColumn: fieldName,
                    sortType: e.value
                });
        }

        if (this.props.onOptionChanged) this.props.onOptionChanged(e);
    }

    onCellClick(e) {
        if (!e || !e.column) return;

        if (this.props.onCellClick) this.props.onCellClick(e);
    }

    onRefresh() {
        this.load();
    }

    onShowFieldChooser() {
        this.showColumnChooser();
    }

    onSearch(searchText) {
        this.state.searchText = searchText;
        this.load();
    }

    onDownload() {
        this.dataSource.callDownloadAPI();
    }

    async onAction(e) {
        if (e.name) this.state.searchConditions[e.name] = e.value;

        this.load();

        if (this.props.onAction && typeof this.props.onAction === 'function') this.props.onAction(e);
    }

    resetVisibility(visible) {
        if (this.tree) {
            var oldVisible = this.tree.option('visible');
            if (oldVisible != visible) this.tree.option('visible', visible);
        }
        if (this.props.showActionBar != false && this.actionBar) this.actionBar.resetVisibility(visible);
    }

    resetColumnVisibility() {
        if (this.tree) {
            this.state.columns.forEach((col) => {
                var oldVisible = col.visible;
                var visible = col.visible;

                if (!col.isSystemCol) {
                    var cnfCol = this.props.columns.find((c) => c.dataField === col.dataField);
                    if (cnfCol) {
                        if (typeof cnfCol.visible === 'object' && cnfCol.visible.type === 'action' && cnfCol.visible.field) {
                            visible = false;
                            var condKey = Object.keys(this.state.searchConditions).find((k) => k === cnfCol.visible.field);
                            if (condKey && this.state.searchConditions[condKey] !== undefined)
                                visible = this.state.searchConditions[condKey] === cnfCol.visible.value;
                        }
                    }
                    this.tree.columnOption(col.name, 'visible', visible);
                }
            });
        }
    }

    renderCheckboxCell(cell) {
        return <CheckBox value={cell.value} hoverStateEnabled={false} activeStateEnabled={false} focusStateEnabled={false} />;
    }

    renderDetailCell(cell) {
        var row = cell.row;
        var rowData = cell.row.data;

        var ar = [];
        if (this.props.showDetail instanceof Array) {
            for (let i = 0; i < this.props.showDetail.length; i++) {
                const item = this.props.showDetail[i];
                ar.push(item);
            }
        } else if (typeof this.props.showDetail === 'object')
            ar.push({
                when: this.props.showDetail.when,
                url: this.props.showDetail.url,
                key: this.props.showDetail.key
            });

        for (let i = 0; i < ar.length; i++) {
            const item = ar[i];

            var when = item.when ? item.when : null;
            if (when && typeof when === 'object') {
                var isValid = true;

                var keys = Object.keys(when);
                for (let j = 0; j < keys.length; j++) {
                    const k = keys[j];
                    if (rowData[k] !== undefined && rowData[k] !== when[k]) isValid = false;
                }

                if (!isValid) continue;
            }

            var url = item.url ? item.url : null;
            var key = null;

            if (url) {
                if (item.key) key = item.key;

                if (!key || !rowData[key]) key = 'code';
                if (!key || !rowData[key]) key = 'id';
                if (!key || !rowData[key]) key = this.props.keyExpr;

                if (key && rowData[key]) {
                    var value = rowData[key];

                    var linkUrl = format('{0}/{1}', url, value);
                    return <AntGridLink value={value} row={row} rowData={rowData} linkUrl={linkUrl} />;
                }
            }
        }

        return <div></div>;
    }

    renderLinkCell(cell) {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        var columns = this.props.columns;

        var linkUrl = '';
        var keyField = dataField;
        if (columns && columns instanceof Array) {
            var field = columns.filter((col) => col.dataField == dataField)[0];
            if (field.link) {
                linkUrl = field.link.url;
                if (field.link.keyField) keyField = field.link.keyField;
            }
        }

        if (!linkUrl.startsWith('/')) linkUrl = '/' + linkUrl;
        if (!linkUrl.endsWith('/')) linkUrl = linkUrl + '/';
        linkUrl = format('{0}{2}', linkUrl, keyField, value);
        return (
            <AntGridLink
                text={value}
                field={dataField}
                value={value}
                row={row}
                rowData={rowData}
                linkUrl={linkUrl}
                // onClick={this.handleLinkClicked}
            />
        );
    }

    renderNoteCell(cell) {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (row.rowIndex % 5 == 1) rowData.note = "nsdsdgsdg";
        // if (row.rowIndex % 5 == 3) rowData.note = "urge sfd sdgsdnt";

        if (!rowData || !rowData.note || String(rowData.note).trim() == '') return <div></div>;

        var notes = rowData.note.split('\n');

        var id = 'ant-tree-note-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-note"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-comment'}></i>
                </Button>
                <Tooltip
                    target={`#${id}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    <div>
                        {notes.map((item, key) => {
                            if (key < notes.length - 1)
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                        <br />
                                    </div>
                                );
                            else
                                return (
                                    <div>
                                        <caption>{item}</caption>
                                    </div>
                                );
                        })}
                    </div>
                </Tooltip>
            </div>
        );
    }

    renderPriorityCell(cell) {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        if (row.rowIndex % 6 == 1) rowData.priority = 'high';
        if (row.rowIndex % 6 == 3) rowData.priority = 'urgent';

        if (!rowData || !rowData.priority || String(rowData.priority).trim() == '') return <div></div>;

        var priority = '';
        if (rowData.priority === 'normal') priority = 'normal';
        if (rowData.priority === 'high') priority = 'high';
        if (rowData.priority === 'urgent') priority = 'urgent';

        if (priority !== 'high' && priority !== 'urgent') return <div></div>;

        var id = 'ant-tree-priority-' + row.rowIndex;

        return (
            <div>
                <Button
                    className={`ant-grid-icon ant-icon-priority-${priority}`}
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={`dx-icon dx-icon-${priority == 'high' ? 'favorites' : 'warning'}`}></i>
                </Button>
                <Tooltip
                    target={`#${id}`}
                    className="ant-tooltip"
                    hideEvent="mouseleave"
                    showEvent={{
                        name: 'mouseenter dxclick keyup'
                    }}
                    hideOnOutsideClick={true}
                >
                    <div>
                        {priority === 'high' && (
                            <div>
                                <caption>Ưu tiên</caption>
                            </div>
                        )}
                        {priority === 'urgent' && (
                            <div>
                                <caption>Khẩn !</caption>
                            </div>
                        )}
                    </div>
                </Tooltip>
            </div>
        );
    }

    renderAttachmentCell(cell) {
        var dataField = cell.column.dataField;
        var value = cell.value;
        var row = cell.row;
        var rowData = cell.row.data;

        // if (!rowData || !rowData.attach || rowData.attach instanceof Array == false) return <div></div>;

        var id = 'ant-tree-attach-' + row.rowIndex;

        return (
            <div>
                <Button
                    className="ant-grid-icon ant-icon-attach"
                    id={id}
                    type="normal"
                    stylingMode="text"
                    focusStateEnabled={false}
                    hoverStateEnabled={false}
                    activeStateEnabled={false}
                >
                    <i className={'dx-icon dx-icon-file'}></i>
                </Button>
            </div>
        );
    }

    render() {
        var selectable = this.props.selectable !== undefined ? this.props.selectable : false;
        var focusable = this.props.allowEdit !== true && (selectable || (this.props.focusable !== undefined ? this.props.focusable : true));

        var columns = [];
        var that = this;

        if (this.props.showNote) {
            columns.push({
                name: 'note',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderNoteCell',
                showInColumnChooser: false
            });
        }

        if (this.props.showAttachments) {
            columns.push({
                name: 'attachment',
                label: ' ',
                width: 30,
                isSystemCol: true,
                alignment: 'center',
                cellTemplate: 'renderAttachmentCell',
                showInColumnChooser: false
            });
        }

        if (this.props.showPriority) {
            columns.push({
                name: 'priority',
                label: ' ',
                width: 30,
                isSystemCol: true,
                alignment: 'center',
                cellTemplate: 'renderPriorityCell',
                showInColumnChooser: false
            });
        }

        if (this.props.showDetail) {
            columns.push({
                name: 'detail',
                label: ' ',
                width: 30,
                alignment: 'center',
                isSystemCol: true,
                cellTemplate: 'renderDetailCell',
                showInColumnChooser: false
            });
        }
        if (columns.length === 0) {
            if (!selectable) {
                columns.push({
                    name: 'seperator',
                    label: ' ',
                    alignment: 'center',
                    editable: false,
                    width: 20,
                    isSystemCol: true,
                    showInColumnChooser: false
                });
            }
        }

        if (this.props.columns instanceof Array) {
            this.props.columns.forEach((col) => {
                columns.push({ ...col, name: 'col' + col.dataField });
            });
        }

        columns.forEach((col) => {
            var colType = col.dataType;
            var colEditor = col.editor;
            var colLabel = col.caption ? col.caption : col.label;
            var colLookupValues = col.lookup && col.lookup.values instanceof Array ? col.lookup.values : null;

            var found = null;
            if (col.dataField && this.props.fields instanceof Array) {
                found = this.props.fields.find((f) => f.field === col.dataField);
                if (found) {
                    if (!colType && found.dataType) colType = found.dataType;
                    if (!colLabel && found.gridLabel) colLabel = found.gridLabel;
                    if (!colLabel && found.label) colLabel = found.label;
                    if (!colLookupValues && found.lookup && found.lookup.values instanceof Array) colLookupValues = found.lookup.values;
                }
            }

            if (colLookupValues instanceof Array)
                colLookupValues = colLookupValues.map((c) => {
                    c.name = AntLocalization.translateText(AntCondition.getValue({}, c.name));
                    return c;
                });

            if (colLookupValues instanceof Array) {
                col.calculateCellValue = (data) => {
                    if (data) {
                        var colValue = data[col.dataField];
                        if (colValue != null) {
                            var obj = colLookupValues.find((f) => f.code === colValue);
                            if (obj) return obj.name;
                        }
                        return colValue;
                    }
                    return null;
                };
            }

            if (!that.state.sortByColumn && col.defaultSort) {
                col.sortIndex = 0;
                col.sortOrder = col.defaultSort.order ? col.defaultSort.order : 'asc';
                that.state.sortByColumn = col.dataField;
                that.state.sortType = col.sortOrder;
            }

            colLabel = AntLocalization.translateText(colLabel);

            col.caption = colLabel;

            if (colType === 'bool' || colEditor == 'CheckBox') {
                if (!col.alignment) col.alignment = 'center';

                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    if (data) {
                        if (typeof data[col.dataField] == 'boolean') return data[col.dataField];
                        if (typeof data[col.dataField] == 'string') return String(data[col.dataField]).trim() !== '';

                        if (typeof data[col.dataField] == 'number') return data[col.dataField] != 0;

                        // if (data[col.dataField] === 1) return true;

                        if (colType === 'bool') return parseInt(data[col.dataField]) === 1;
                        if (colType === 'int') return parseInt(data[col.dataField]) > 0;
                        if (colType === 'float') return parseFloat(data[col.dataField]) > 0;
                        else return parseFloat(data[col.dataField]) > 0;
                    }
                    return false;
                };
                col.cellTemplate = 'renderCheckboxCell';
                col.dataType = 'boolean';
            }

            if (colType === 'int') {
                if (!col.format) col.format = '#,##0';
                // if (!col.format) col.format = { type: 'fixedPoint' };
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseInt(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseInt(value);
                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'float' || colType === 'decimal') {
                if (!col.format) col.format = '#,##0.' + String('#').repeat(found && found.decimalDigit ? found.decimalDigit : 2);

                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'day') {
                if (!col.format) col.format = '#,##0 ngày';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'month') {
                if (!col.format) col.format = '#,##0 tháng';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'year') {
                if (!col.format) col.format = '#,##0 năm';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'period') {
                if (!col.format) col.format = '#,##0 kỳ';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'percent') {
                if (!col.format)
                    col.format = {
                        type: 'percent',
                        precision: found && found.decimalDigit ? found.decimalDigit : 0
                    };
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'number';
            }

            if (colType === 'currency') {
                if (!col.format) col.format = '#,##0 đ';
                if (!col.alignment) col.alignment = 'right';
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };

                col.dataType = 'number';
            }

            if (colType === 'date') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format)
                    col.format = function (value) {
                        if (value === null || value === undefined) return '';
                        return AntTime.fromUnix(value).format('DD/MM/YY');
                    };
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'date';
            }

            if (colType === 'datetime') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format)
                    col.format = function (value) {
                        return AntTime.fromUnix(value).format('DD/MM/YY HH:mm');
                    };
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'date';
            }

            if (colType === 'time') {
                if (!col.alignment) col.alignment = 'center';
                if (!col.format)
                    col.format = function (value) {
                        return AntTime.fromUnix(value).format('hh:mm A');
                    };
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);

                    var value = data ? data[col.dataField] : null;
                    if (value === null || value === undefined) return value;
                    if (typeof value === 'number') return parseFloat(value);

                    return value;
                };
                col.calculateDisplayValue = (data) => {
                    var value = data ? data[col.dataField] : null;
                    if (typeof value === 'number') value = parseFloat(value);

                    if (value === 0 && col.displayZeroAsEmpty !== false) value = '';
                    if (value === null || value === undefined) value = '';

                    return value;
                };
                col.dataType = 'date';
            }

            if (colType === 'join') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array)
                        return fields
                            .map((f) => (data ? data[f] : null))
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .join(col.separator ? col.separator : ', ');

                    return '';
                };
                col.dataType = 'string';
            }
            if (colType === 'first') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array)
                        return fields
                            .map((f) => (data ? data[f] : null))
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .shift();

                    return '';
                };
                col.dataType = 'string';
            }
            if (colType === 'last') {
                col.calculateCellValue = (data) => {
                    if (col.customCellValue) return col.customCellValue(data);
                    var fields = col.fields;
                    if (fields instanceof Array)
                        return fields
                            .map((f) => (data ? data[f] : null))
                            .filter((f) => Boolean(f))
                            .map((f) => String(f))
                            .pop();

                    return '';
                };
                col.dataType = 'string';
            }

            if (!col.alignment && String(col.dataField).endsWith('status')) col.alignment = 'center';
            if (!col.alignment) col.alignment = 'left';
            if (col.link) col.cellTemplate = 'renderLinkCell';
            if (this.props.allowEdit) {
                col.allowEditing = Boolean(col.editable);
                col.editorOptions = {
                    ...this.props.editorOptions
                };
                if (colType === 'currency') col.editorOptions.format = '#,##0 đ';

                if (colType === 'int' || colType === 'fixedPoint') col.editorOptions.format = '#,##0';

                if (colType === 'float' || colType === 'decimal')
                    col.editorOptions.format = '#,##0.' + String('#').repeat(found && found.decimalDigit ? found.decimalDigit : 2);

                if (colType === 'percent')
                    col.editorOptions.format = {
                        type: 'percent',
                        precision: found && found.decimalDigit ? found.decimalDigit : 0
                    };
                // col.editCellTemplate = 'renderCellEditor';
            }
        });

        if (this.props.columns instanceof Array)
            this.props.columns.forEach((col) => {
                var visible = true;
                if (typeof col.visible === 'object' && col.visible.type === 'action' && col.visible.field) {
                    visible = false;
                    var condKey = Object.keys(that.state.searchConditions).find((k) => k === col.visible.field);
                    if (condKey && that.state.searchConditions[condKey] !== undefined)
                        visible = that.state.searchConditions[condKey] === col.visible.value;
                } else if (typeof col.visible === 'boolean') visible = col.visible;

                var col2 = columns.find((c) => c.name === 'col' + col.dataField);
                if (col2) col2.visible = visible;
            });

        var isAllowNew = this.props.allowNew !== undefined ? this.props.allowNew : false;

        this.state.columns = columns;

        return (
            <React.Fragment>
                {this.props.showActionBar != false && (
                    <AntGridBar
                        ref={(ref) => {
                            this.actionBar = ref;
                        }}
                        showRefresh={Boolean(this.props.showRefresh) && !isAllowNew}
                        showEdit={this.props.showEdit}
                        showDelete={this.props.showDelete}
                        showAdd={this.props.showAdd}
                        showImport={this.props.showImport}
                        showDownload={this.props.showDownload}
                        showSearchBar={this.props.showSearchBar}
                        searchBarWidth={this.props.searchBarWidth}
                        showFieldChooser={this.props.showFieldChooser}
                        locationRefresh={this.props.locationRefresh ? this.props.locationRefresh : 'before'}
                        locationEdit={this.props.locationEdit ? this.props.locationEdit : 'before'}
                        locationDelete={this.props.locationDelete ? this.props.locationDelete : 'before'}
                        locationAdd={this.props.locationAdd ? this.props.locationAdd : 'before'}
                        locationFilterBySelected={this.props.locationFilterBySelected ? this.props.locationFilterBySelected : 'after'}
                        locationImport={this.props.locationImport ? this.props.locationImport : 'before'}
                        locationDownload={this.props.locationDownload ? this.props.locationDownload : 'after'}
                        locationSearchBar={this.props.locationSearchBar ? this.props.locationSearchBar : 'after'}
                        searchText={this.state.searchText}
                        onRefreshClick={this.onRefresh.bind(this)}
                        onShowFieldChooser={this.onShowFieldChooser.bind(this)}
                        onSearch={this.onSearch.bind(this)}
                        onAction={this.onAction.bind(that)}
                        onDownloadClick={this.onDownload.bind(this)}
                        onEditClick={this.props.onEdit}
                        onDeleteClick={this.props.onDelete}
                        onImportClick={this.props.onImport}
                        onAddClick={this.props.onAdd}
                        items={this.props.actionItems instanceof Array ? this.props.actionItems : []}
                    />
                )}
                {this.props.showActionBar === false && <p />}

                <TreeList
                    ref={(ref) => {
                        this.tree = ref ? ref.instance : undefined;
                    }}
                    noDataText={AntLocalization.translateText({ vi: 'Không có dữ liệu !', en: 'Have no data !', fr: 'Aucune donnée !', es: '¡Sin datos!', id: 'Tidak ada data!', ja: 'データがありません！', zh: '没有数据！', ko: '데이터 없음!', hi: 'कोई डेटा नहीं!', ar: 'لا توجد بيانات!' })}
                    className={'dx-card wide-card'}
                    dataSource={this.dataSource.instance()}
                    keyExpr={this.props.keyExpr}
                    parentIdExpr={this.props.parentIdExpr}
                    // remoteOperations={true}
                    rootValue={null}
                    focusedRowEnabled={true}
                    onFocusedRowChanged={!this.props.selectable ? this.onFocusedRowChanged.bind(this) : undefined}
                    onSelectionChanged={this.props.selectable ? this.onSelectionChanged.bind(this) : undefined}
                    onOptionChanged={this.onOptionChanged}
                    onCellClick={this.onCellClick}
                    autoExpandAll={true}
                    defaultFocusedRowIndex={0}
                    allowColumnResizing={true}
                    columnAutoWidth={true}
                    columnResizingMode={'widget'}
                    columnHidingEnabled={true}
                    showColumnLines={false}
                    showRowLines={true}
                    showBorders={true}
                    hoverStateEnabled={true}
                    rowAlternationEnabled={true}
                    keyboardNavigation={
                        this.props.keyboardNavigation !== undefined
                            ? this.props.keyboardNavigation
                            : {
                                  enterKeyAction: 'moveFocus',
                                  enterKeyDirection: 'row',
                                  enabled: true,
                                  editOnKeyPress: true
                              }
                    }
                    loadPanel={{ enabled: false }}
                    selection={
                        this.props.selectable
                            ? {
                                  mode: 'multiple',
                                  recursive: this.props.autoSelectParent !== undefined ? this.props.autoSelectParent : true,
                                  selectAllMode: 'allPages',
                                  showCheckBoxesMode: 'always'
                              }
                            : undefined
                    }
                    columnChooser={{
                        emptyPanelText: '',
                        enabled: false,
                        mode: 'select',
                        title: 'Ẩn hiện cột'
                    }}
                    pager={{
                        showInfo: true,
                        infoText: '{2} dòng',
                        showPageSizeSelector: true,
                        allowedPageSizes: this.props.allowedPageSizes,
                        visible: true
                    }}
                    sorting={{
                        mode: this.props.sortable ? 'single' : 'none',
                        clearText: 'Bỏ sắp xếp',
                        ascendingText: 'A->Z',
                        descendingText: 'Z->A'
                    }}
                    scrolling={{
                        mode: 'standard'
                    }}
                    columns={columns}
                >
                    <Paging
                        enabled={true}
                        defaultPageSize={
                            this.props.defaultPageSize ? this.props.defaultPageSize : this.props.allowedPageSizes ? this.props.allowedPageSizes[0] : 7
                        }
                        defaultPageIndex={this.state.pageIndex}
                        pageIndex={this.state.pageIndex}
                        pageSize={this.state.pageSize}
                    />
                    <Template name={'renderLinkCell'} render={this.renderLinkCell.bind(this)} />
                    <Template name={'renderCheckboxCell'} render={this.renderCheckboxCell.bind(this)} />
                    <Template name={'renderNoteCell'} render={this.renderNoteCell.bind(this)} />
                    <Template name={'renderAttachmentCell'} render={this.renderAttachmentCell.bind(this)} />
                    <Template name={'renderPriorityCell'} render={this.renderPriorityCell.bind(this)} />
                    <Template name={'renderDetailCell'} render={this.renderDetailCell.bind(this)} />
                </TreeList>
            </React.Fragment>
        );
    }
}
